import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import ReleasingMusicHeroSection from '../../components/HowItWorks/ReleasingMusicHeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { releasingMusic } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:releaseMusicPage.headerTitle.chooseType',
    title: 'howItWorks:releaseMusicPage.chooseType',
    subtitle: 'howItWorks:releaseMusicDescription.chooseType',
    media: '/static/animations/release.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:releaseMusicPage.headerTitle.addDetails',
    title: 'howItWorks:releaseMusicPage.fillInDetails',
    subtitle: 'howItWorks:releaseMusicDescription.fillInDetails',
    media: '/static/animations/adddetails.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:releaseMusicPage.headerTitle.distribute',
    title: 'howItWorks:releaseMusicPage.distribute',
    subtitle: 'howItWorks:releaseMusicDescription.distribute',
    media: '/static/animations/selected.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 4,
    headerTitle: 'howItWorks:releaseMusicPage.headerTitle.earnMoney',
    title: 'howItWorks:releaseMusicPage.earnMoney',
    subtitle: 'howItWorks:releaseMusicDescription.earnMoney',
    media: '/static/animations/payout.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>
        {t('howItWorks:releasingMusic.title')}
      </BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <ReleasingMusicHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}

      <FAQ page={releasingMusic} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/releasing-music',
  });
  return { ...getTranslations };
};

export default Index;
